<ion-toolbar class="search-bar-filters tablet-bar">
    <ion-buttons slot="start" style="padding-right: 0.1em;">
        <ion-button
            type="button"
            fill="clear"
            [disabled]="programBundleRowActivated$ | async"
        >
            <fa-icon
                [icon]="faFilter"
                slot="start"
                style="padding-right: 10px;"
            ></fa-icon>
            <ion-label>Select Filters:</ion-label>
        </ion-button>
    </ion-buttons>
    <ion-buttons slot="start">
        <ion-button
            type="button"
            fill="outline"
            (click)="presentPopover($event, 'specialty')"
            [disabled]="programBundleRowActivated$ | async"
        >
            Medical specialties
        </ion-button>
        <ion-button
            type="button"
            fill="outline"
            (click)="presentPopover($event, 'states')"
            [disabled]="programBundleRowActivated$ | async"
        >
            States
        </ion-button>
        <ion-button
            type="button"
            fill="outline"
            (click)="presentPopover($event, 'cities')"
            [disabled]="programBundleRowActivated$ | async"
        >
            Cities
        </ion-button>
        <ion-button
            type="button"
            fill="outline"
            (click)="presentPopover($event, 'tags')"
            [disabled]="programBundleRowActivated$ | async"
        >
            Tags
        </ion-button>
        <ion-button
            type="button"
            fill="outline"
            (click)="presentPopover($event, 'types')"
            [disabled]="programBundleRowActivated$ | async"
        >
            Rotation type
        </ion-button>
        <ion-button
            type="button"
            fill="outline"
            (click)="presentPopover($event, 'dates')"
            [disabled]="programBundleRowActivated$ | async"
        >
            Months
        </ion-button>
    </ion-buttons>
    <ion-buttons slot="secondary">
        <ion-button type="button" [disabled]="showProgramBundle$ | async">
            <fa-icon [icon]="faSort" slot="start" style="padding-right: 10px;">
            </fa-icon>
            <ion-label>Sort by:</ion-label>
        </ion-button>
        <ion-button fill="outline">
            <ion-select
                [interfaceOptions]="customAlertOptions"
                interface="popover"
                class="sort-select"
                (ionChange)="sortBy($event)"
                [(ngModel)]="sortOrder"
                [disabled]="showProgramBundle$ | async"
            >
                <ion-select-option value="date-desc"
                    >Newest First</ion-select-option
                >
                <ion-select-option value="date-asc"
                    >Oldest First</ion-select-option
                >
                <!-- <ion-select-option value="rate-desc">Highest Rated First</ion-select-option> -->
                <ion-select-option value="price-desc"
                    >Highest Price First</ion-select-option
                >
                <ion-select-option value="price-asc"
                    >Lowest Price First</ion-select-option
                >
                <!-- <ion-select-option value="rate-desc"
                    >Highest Rated First</ion-select-option
                > -->
            </ion-select>
        </ion-button>
    </ion-buttons>
    <ion-item slot="end">
        <ion-label>Show Map:</ion-label>
        <ion-toggle
            slot="end"
            (ionChange)="toggleMap($event)"
            [(ngModel)]="showMap"
            [disabled]="programBundleMapDisabled$ | async"
        ></ion-toggle>
    </ion-item>
</ion-toolbar>
<ion-toolbar class="search-bar-filters">
    <ion-buttons slot="start">
        <ion-item lines="none">
            <ion-label color="text" class="context-label">
                {{ context$ | async }}
                <a
                    *ngIf="showSuggested$ | async"
                    type="button"
                    fill="clear"
                    color="secondary"
                    size="small"
                    [routerLink]="['/profile/clinical-preferences']"
                >
                    View your clinical preferences
                </a>
            </ion-label>
        </ion-item>
    </ion-buttons>
    <ion-buttons slot="secondary" class="clear-filters">
        <ion-button color="secondary" type="button" (click)="reset()">
            <ion-icon name="refresh" slot="start"></ion-icon>
            <ion-label>Clear all filters</ion-label>
        </ion-button>
        <ion-chip> {{ programCount$ | async }} Results </ion-chip>
    </ion-buttons>
    <!-- <ion-progress-bar
        *ngIf="search?.loading"
        type="indeterminate"
        color="secondary"
    ></ion-progress-bar> -->
</ion-toolbar>
